import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "grid-block account-balance" }
const _hoisted_3 = { class: "account-balance__title" }
const _hoisted_4 = { class: "account-balance__value" }
const _hoisted_5 = { class: "account-balance__btn" }
const _hoisted_6 = { class: "grid-block account-tariff" }
const _hoisted_7 = { class: "grid-block account-history" }
const _hoisted_8 = { class: "account-history--link" }
const _hoisted_9 = { class: "grid-block account-bottom account-skeleton__addons" }
const _hoisted_10 = { class: "account-skeleton__addons-list" }
const _hoisted_11 = { class: "grid-block account-services" }
const _hoisted_12 = { class: "account-services__title" }
const _hoisted_13 = { class: "account-services__body" }

import { useI18n } from "vue-i18n";
import BaseSkeleton from "@/components/base/BaseSkeleton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountSkeleton',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "account account-skeleton",
    role: "status",
    "aria-busy": "true",
    "aria-label": _unref(t)('common.labels.loadingAlt')
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseSkeleton, {
          width: "88px",
          height: "14px"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseSkeleton, {
          width: "132px",
          height: "34px",
          radius: "10px"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseSkeleton, {
          class: "account-skeleton__balance-btn",
          height: "44px",
          radius: "16px"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(BaseSkeleton, {
        class: "account-skeleton__tariff",
        radius: "32px"
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(BaseSkeleton, {
        class: "account-history--pic",
        width: "48px",
        height: "48px",
        radius: "50%"
      }),
      _createVNode(BaseSkeleton, {
        width: "176px",
        height: "18px"
      }),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(BaseSkeleton, {
          width: "24px",
          height: "24px",
          radius: "50%"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(BaseSkeleton, {
        class: "account-skeleton__addons-title",
        width: "212px",
        height: "22px"
      }),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
          return _createVNode(BaseSkeleton, {
            key: index,
            class: "account-skeleton__addons-item",
            radius: "18px"
          })
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(BaseSkeleton, {
          width: "128px",
          height: "22px"
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (index) => {
          return _createVNode(BaseSkeleton, {
            key: index,
            class: "account-skeleton__service",
            radius: "18px"
          })
        }), 64))
      ])
    ])
  ], 8, _hoisted_1))
}
}

})